import api from "../../utils/api";
import {
  LOGOUT
} from "../types";

const normalizeNameText = (value) => {
    if (value === undefined) return undefined;
    if (value === null) return null;

    const text = String(value).replace(/\s+/g, " ").trim();
    return text || null;
};

const normalizePersonNamePayload = ({ displayName, firstName, middleName, lastName, generation, ...payload }) => {
    return {
        ...payload,
        firstName: normalizeNameText(firstName),
        middleName: normalizeNameText(middleName),
        lastName: normalizeNameText(lastName),
        generation: normalizeNameText(generation),
        displayName: normalizeNameText(displayName)
    };
};

export const me = () => async (dispatch) => {
    try {
        const res = await api.get(`/people/me`);
        return res.data;
    } catch (err) {
        dispatch({
            type: LOGOUT
        });
    }
};

export const mine = ({ displayName, firstName, middleName, lastName, generation, email, birthDate, phone, fax, residenceUuid, Residence }) => async (dispatch) => {
    try {
        const res = await api.post(`/people/me`, normalizePersonNamePayload({ displayName, firstName, middleName, lastName, generation, email, birthDate, phone, fax, residenceUuid, Residence }));
        return res.data;
    } catch (error) {
        dispatch({
            type: LOGOUT
        });
    }
}
